import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TenantProperties } from 'libs/domain/tenant/tenant.interface';
import { HttpClient } from "@angular/common/http";
import { Environment, ENVIRONMENT } from "../auth/auth.tokens";

@Injectable({ providedIn: 'root' })
export class SchemaService {
  private http = inject(HttpClient);
  private options: Environment = inject(ENVIRONMENT);
  private baseUrl;

  constructor() {
    this.baseUrl = `${this.options.baseUrl.data}`;
  }

  getSchemaProperties(tenantId: string): Observable<TenantProperties> {
    return this.http.get<TenantProperties>(`${this.baseUrl}/communities/${tenantId}/properties`);
  }
}